var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBpostOnTheRoad = function SvgBpostOnTheRoad(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 526.8 382.14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-7{fill:none;}.cls-2{fill:#fff;}.cls-3{stroke:#393536;stroke-linecap:round;}.cls-3,.cls-7{stroke-linejoin:round;stroke-width:12px;}.cls-4{fill:#ed1c24;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:url(#Degradado_sin_nombre);}.cls-7{stroke:#303133;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.52,
    y: 6.03,
    width: 218.12,
    height: 181.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    x1: -35.09,
    y1: 611.23,
    x2: -34.09,
    y2: 611.23,
    gradientTransform: "matrix(218.12, 0, 0, -218.12, 7778.16, 133414.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69b18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9c71a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-2",
    d: "M302.93,224.74c-12.91,28.11-42.87,57.15-67.29,64.06-24.43,7.37-33.18-9.68-20.28-37.79l8.3-2.77c-8.76,18.44-2.77,29.5,13.36,24.89,15.67-4.61,35.49-23.5,44.24-41.94l21.67-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "cls-3",
    d: "M302.93,224.74c-12.91,28.11-42.87,57.15-67.29,64.06-24.43,7.37-33.18-9.68-20.28-37.79l8.3-2.77c-8.76,18.44-2.77,29.5,13.36,24.89,15.67-4.61,35.49-23.5,44.24-41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "cls-2",
    d: "M227.8,247.32c-4.14,9.22-1.38,15.21,6.92,12.45,8.29-2.31,18-12,22.58-21.67l-29.5,9.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-3",
    d: "M227.8,247.32c-4.14,9.22-1.38,15.21,6.92,12.45,8.29-2.31,18-12,22.58-21.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-2",
    d: "M24.61,294.45v33.28H520.8V296.31h-9.19V194l-51-106.06H340.93V6H223.7V6H122.81V63H24.61V187.11H6V294.45H24.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "cls-3",
    d: "M24.61,294.45v33.28H520.8V296.31h-9.19V194l-51-106.06H340.93V6H223.7V6H122.81V63H24.61V187.11H6V294.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-2",
    d: "M340.93,87.91v99.2H24.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "cls-3",
    d: "M340.93,87.91v99.2H24.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-3",
    d: "M340.93,187.11v42.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-3",
    d: "M122.81,63V187.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-3",
    d: "M55,63V87.91H91.05V63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-3",
    d: "M379.26,87.91v74.87A32.22,32.22,0,0,0,411.48,195H511.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-3",
    d: "M24.61,294.45h32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-3",
    d: "M511.61,296.31H488.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "cls-3",
    d: "M511.61,251.65H495.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "cls-2",
    d: "M84.36,327.47A48.67,48.67,0,1,0,133,278.81a48.67,48.67,0,0,0-48.67,48.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "cls-3",
    d: "M84.36,327.47A48.67,48.67,0,1,0,133,278.81,48.67,48.67,0,0,0,84.36,327.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "cls-2",
    d: "M110.72,327.47A22.31,22.31,0,1,0,133,305.17a22.31,22.31,0,0,0-22.31,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "cls-3",
    d: "M110.72,327.47A22.31,22.31,0,1,0,133,305.17a22.31,22.31,0,0,0-22.31,22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    className: "cls-2",
    d: "M355.42,327.47a48.67,48.67,0,1,0,48.67-48.66,48.67,48.67,0,0,0-48.67,48.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "cls-3",
    d: "M355.42,327.47a48.67,48.67,0,1,0,48.67-48.66A48.67,48.67,0,0,0,355.42,327.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    className: "cls-2",
    d: "M381.79,327.47a22.31,22.31,0,1,0,22.3-22.3,22.3,22.3,0,0,0-22.3,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    className: "cls-3",
    d: "M381.79,327.47a22.31,22.31,0,1,0,22.3-22.3A22.3,22.3,0,0,0,381.79,327.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "cls-4",
    d: "M307.09,228.11c-12.49,27.19-41.46,55.28-65.09,62-23.62,7.14-32.09-9.36-19.61-36.55l8-2.67c-8.47,17.83-2.67,28.53,12.93,24.07,15.16-4.46,34.33-22.74,42.8-40.57l20.95-6.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    className: "cls-4",
    d: "M234.42,250c-4,8.92-1.33,14.71,6.69,12,8-2.23,17.39-11.59,21.84-21L234.42,250"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    className: "cls-6",
    d: "M341.64,187.11H123.52V6H341.64V187.11"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    className: "cls-3",
    d: "M341.64,187.11H123.52V6H341.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    className: "cls-2",
    d: "M269.9,6V84.63L232.81,60.88,196.57,84.63V6H269.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    className: "cls-7",
    d: "M269.9,6V84.63L232.81,60.88,196.57,84.63V6Z"
  })))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBpostOnTheRoad);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";